import { UserManager, Log } from 'oidc-client';
import { createUserManagerConfig, determineMemberSiteUrl } from './config';

const userManager =
  typeof window !== 'undefined'
    ? new UserManager(createUserManagerConfig(window))
    : undefined;

const siteUrl = determineMemberSiteUrl();
if (siteUrl === 'https://my-sandbox.ecri.org' || siteUrl === '/') {
  //dev site gets verbose logging
  Log.logger = console;
  Log.level = Log.DEBUG;
} else {
  Log.logger = console;
  Log.level = Log.ERROR;
}

export default userManager;

let isProcessingRedirect = false;
let loginRedirectFinished = false;
//https://github.com/IdentityModel/oidc-client-js/issues/1044#issuecomment-802783853
//if somehow this gets retriggered during the processing of a login, state will be wiped out and cause an error
//we'll do this to ensure globally that an unexpected unmount/remount of the call back does not
//retrigger the call back if already in process.
//this may make more sense to be into redux later
export const processRedirectSafe = async () => {
  if (loginRedirectFinished) {
    const u = await userManager?.getUser();
    return u;
  }

  if (isProcessingRedirect) {
    return null;
  }

  isProcessingRedirect = true;
  const u = await userManager?.signinRedirectCallback();
  return u;
};

export const finishRedirectSafe = () => {
  loginRedirectFinished = true;
  isProcessingRedirect = false;
};
